function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_9916_21076)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 471,
  height: 640,
  fill: "url(#paint0_linear_9916_21076)"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.3
}, /*#__PURE__*/React.createElement("path", {
  d: "M32.9844 -0.999687V559.307",
  stroke: "url(#paint1_linear_9916_21076)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.5 -0.999687V559.307",
  stroke: "url(#paint2_linear_9916_21076)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M174.016 -0.999687V559.307",
  stroke: "url(#paint3_linear_9916_21076)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M244.539 -0.999687V559.307",
  stroke: "url(#paint4_linear_9916_21076)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M315.055 -0.999687V559.307",
  stroke: "url(#paint5_linear_9916_21076)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M385.57 -0.999687V559.307",
  stroke: "url(#paint6_linear_9916_21076)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M456.086 -0.999687V559.307",
  stroke: "url(#paint7_linear_9916_21076)"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.3
}, /*#__PURE__*/React.createElement("path", {
  d: "M-87 383.637L671.048 383.637",
  stroke: "url(#paint8_linear_9916_21076)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-87 319.531L671.048 319.531",
  stroke: "url(#paint9_linear_9916_21076)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-87 255.425L671.048 255.425",
  stroke: "url(#paint10_linear_9916_21076)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-87 191.319L671.048 191.319",
  stroke: "url(#paint11_linear_9916_21076)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-87 127.212L671.048 127.212",
  stroke: "url(#paint12_linear_9916_21076)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-87 63.1063L671.048 63.1062",
  stroke: "url(#paint13_linear_9916_21076)"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 454.802,
  cy: 301.601,
  r: 10.257,
  fill: "url(#paint14_linear_9916_21076)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 173.373,
  cy: 438.146,
  r: 40.3868,
  fill: "url(#paint15_linear_9916_21076)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M421 616.648C421 593.119 437.56 574.058 458 574.058C478.441 574.058 495 593.119 495 616.648C495 640.176 478.441 659.237 458 659.237C437.56 659.237 421 640.176 421 616.648Z",
  fill: "url(#paint16_linear_9916_21076)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M153.5 348.355C59.3177 299.873 -69.5 305.355 -163 394.855V725.422L668.5 739.422C705.333 677.422 780.724 434.023 688 484.355C343.5 671.355 272 409.355 153.5 348.355Z",
  fill: "url(#paint17_linear_9916_21076)"
}), /*#__PURE__*/React.createElement("rect", {
  x: 409.422,
  y: 234.327,
  width: 0.903823,
  height: 70.4982,
  fill: "url(#paint18_linear_9916_21076)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 410.013,
  cy: 234.012,
  r: 6.0125,
  fill: "url(#paint19_radial_9916_21076)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 410.013,
  cy: 234.013,
  r: 1.81773,
  fill: "#EDFAFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M237 599C351.875 599 445 507.666 445 395C445 282.334 351.875 191 237 191C122.125 191 29 282.334 29 395C29 507.666 122.125 599 237 599Z",
  fill: "#EED0FD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M461.513 441.09C496.279 441.09 524.463 412.908 524.463 378.145C524.463 343.381 496.279 315.2 461.513 315.2C426.747 315.2 398.563 343.381 398.563 378.145C398.563 412.908 426.747 441.09 461.513 441.09Z",
  fill: "#EAF8FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.3094 409.31C40.3922 400.601 35.0207 391.854 26.3118 389.771C17.6029 387.688 8.85449 393.06 6.7717 401.768C4.68892 410.476 10.0604 419.224 18.7693 421.306C27.4782 423.389 36.2266 418.018 38.3094 409.31Z",
  fill: "#EAF8FF"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M295.042 301.75C295.042 303.429 294.717 305.055 294.122 306.572H242.495C242.441 306.545 242.414 306.517 242.387 306.463C242.387 306.517 242.36 306.545 242.36 306.572C242.36 306.572 70.0005 307.682 70.0005 306.274C70.0005 291.701 81.1213 279.89 94.8668 279.89C98.0867 279.89 101.144 280.541 103.958 281.705C106.583 279.484 109.911 278.157 113.51 278.157C118.732 278.157 123.359 280.92 126.146 285.173C129.88 276.938 138.89 270.572 150.146 268.324C153.069 267.701 156.18 267.376 159.373 267.376C161.348 267.376 163.269 267.484 165.164 267.728C172.388 253.616 186.512 244 202.747 244C223.528 244 240.845 259.737 244.714 280.568C247.041 279.024 249.801 278.157 252.75 278.157C258.649 278.157 263.79 281.705 266.333 286.906C268.877 285.985 271.718 285.443 274.721 285.443C285.923 285.443 295.042 292.757 295.042 301.75Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M386.238 303.021C386.238 304.383 385.977 305.7 385.5 306.946H343.448C343.419 306.917 343.404 306.888 343.376 306.859C343.376 306.888 343.361 306.917 343.347 306.946C343.347 306.946 342.218 306.946 340.179 306.975C319.362 307.091 202.999 307.742 202.999 306.714C202.999 294.839 212.069 285.223 223.251 285.223C225.87 285.223 228.372 285.745 230.658 286.701C232.784 284.876 235.504 283.804 238.44 283.804C242.693 283.804 246.469 286.063 248.726 289.524C248.754 289.467 248.783 289.394 248.812 289.336C250.982 284.717 255.206 280.821 260.674 278.272C265.057 276.216 270.222 275.028 275.777 275.028C277.382 275.028 278.959 275.13 280.493 275.318C286.38 263.82 297.88 256 311.102 256C328.013 256 342.131 268.801 345.271 285.774C347.166 284.528 349.408 283.804 351.809 283.804C356.626 283.804 360.807 286.686 362.875 290.929C364.959 290.176 367.259 289.756 369.689 289.756C376.227 289.756 381.869 292.797 384.56 297.2C385.63 298.952 386.238 300.936 386.238 303.021Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 40.5,
  cy: 465.5,
  r: 13.5,
  fill: "url(#paint20_linear_9916_21076)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M523.988 292.337C524.014 296.992 521.451 301.07 517.643 303.252L451.205 303.612C449.842 301.793 449.015 299.539 449 297.104C448.966 290.957 453.991 285.96 460.198 285.926C462.466 285.914 464.577 286.571 466.354 287.7C467.761 283.274 471.942 280.049 476.893 280.022C476.843 270.673 484.479 263.05 493.945 263C503.413 262.948 511.134 270.49 511.185 279.836C518.206 279.798 523.947 285.384 523.985 292.337H523.988Z",
  fill: "#CEF2FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M317.04 150.97L220.19 212.56L149 167.55L245.95 98.05L317.04 150.97Z",
  fill: "url(#paint21_linear_9916_21076)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M317.04 180.68L221.05 239.49L149.86 196.06L245.95 129.68L317.04 180.68Z",
  fill: "url(#paint22_linear_9916_21076)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M317.04 213.81L221.14 270.19L149.86 228.43L245.86 164.91L317.04 213.81Z",
  fill: "url(#paint23_linear_9916_21076)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M149.86 503.11L245.95 463.2V184.28L149.86 246.33V503.11Z",
  fill: "url(#paint24_linear_9916_21076)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M317.04 434.64L245.95 400.13V184.28L317.04 231.95V434.64Z",
  fill: "#E8EEFD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M245.95 142.49L149.86 207.85V228.43L245.95 164.85V142.49Z",
  fill: "url(#paint25_linear_9916_21076)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M317.04 192.71L245.95 142.49V164.97L317.04 213.81V192.71Z",
  fill: "#E8EEFD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M149.86 176.4L245.95 108.33V129.68L149.86 196.06V176.4Z",
  fill: "url(#paint26_linear_9916_21076)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M317.04 160.63L245.95 108.33V129.68L317.04 180.68V160.63Z",
  fill: "#E8EEFD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M149 144.5L245.95 73V98.05L149 167.55V144.5Z",
  fill: "url(#paint27_linear_9916_21076)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M317.04 127.45L245.95 73V98.05L317.04 150.97V127.45Z",
  fill: "#E8EEFD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M206.66 227.24V379.32L204.77 380.26V411.54L233.02 398.15V210.62L206.66 227.24Z",
  fill: "#E8EEFD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M161.72 255.59V420.23L183.6 409.63V241.79L161.72 255.59Z",
  fill: "#E8EEFD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M306 347.49L258.7 358.13V212.56L306 243.47V347.49Z",
  fill: "url(#paint28_linear_9916_21076)"
}), /*#__PURE__*/React.createElement("rect", {
  x: 432.176,
  y: 262.192,
  width: 2.032,
  height: 85.3441,
  fill: "url(#paint29_linear_9916_21076)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 433.242,
  cy: 262.242,
  r: 12.2423,
  fill: "url(#paint30_radial_9916_21076)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 433.24,
  cy: 262.243,
  r: 3.70115,
  fill: "#EDFAFF"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M280.61 340L280.777 482.41L313.358 488.237L332.975 372.037L280.61 340Z",
  fill: "url(#paint31_linear_9916_21076)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M359.946 620.067L343.055 378.484L315.76 396.161L249.702 451.938L247.094 468.543L359.946 620.067Z",
  fill: "url(#paint32_linear_9916_21076)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M-15.998 606.651V646.316H443.914L443.914 606.661L-15.998 606.651Z",
  fill: "#A8D5FF"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M391.384 589.791L391.847 566.278H36.2524L39.6188 586.396L391.384 589.791Z",
  fill: "#A8D5FF"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M361.732 556.868L361.998 542.773L69.2717 541.632L71.0829 556.868H361.732Z",
  fill: "#A8D5FF"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M339.234 538.295L339.194 525.845L89.5027 526.366L90.7232 539.161L339.234 538.295Z",
  fill: "#A8D5FF"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M326.781 525.176V516.328L105.024 515.078L105.339 525.176H326.781Z",
  fill: "#A8D5FF"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M116.344 514.27L313.769 515.077V505.668L302.951 505.727V497.764L296.622 497.784L296.14 492.243L286.72 492.184L286.553 485.451H280.469L280.154 480.54L274.347 480.501L274.071 475.835L267.437 475.796V470.629H261.246L261.334 468.542V464.723L343.052 378.484L286.129 340.374L280.607 340L319.32 371.761L168.425 470.629H163.533V475.166L157.627 475.136V479.713L151.504 479.664V485.451H143.955L144.122 491.308L136.523 491.258L136.582 498.296L127.231 498.325L127.507 506.632L116.069 506.691L116.344 514.27Z",
  fill: "url(#paint33_linear_9916_21076)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M443.915 606.66L391.382 589.79L39.6168 586.395L-15.9971 606.65L443.915 606.66Z",
  fill: "url(#paint34_linear_9916_21076)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M36.2534 566.276L71.2065 556.867H361.738L391.848 566.276H36.2534Z",
  fill: "url(#paint35_linear_9916_21076)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M69.2727 541.631L92.286 539.121L339.231 538.294L361.999 542.773L69.2727 541.631Z",
  fill: "url(#paint36_linear_9916_21076)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M326.782 516.326L313.77 515.076L116.384 514.269L105.025 515.076L326.782 516.326Z",
  fill: "url(#paint37_linear_9916_21076)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M116.07 506.691L127.498 505.589L302.952 504.398L313.77 505.668L116.07 506.691Z",
  fill: "url(#paint38_linear_9916_21076)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M339.195 525.844L326.783 524.377L102.999 525.174L89.5037 526.365L339.195 525.844Z",
  fill: "url(#paint39_linear_9916_21076)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M368.684 310.225C368.684 304.384 372.795 299.651 377.87 299.651C382.945 299.651 387.056 304.384 387.056 310.225C387.056 316.067 382.945 320.8 377.87 320.8C372.795 320.8 368.684 316.067 368.684 310.225Z",
  fill: "url(#paint40_linear_9916_21076)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.35,
  d: "M361 570.36C361 564.955 364.804 560.576 369.5 560.576C374.196 560.576 378 564.955 378 570.36C378 575.765 374.196 580.144 369.5 580.144C364.804 580.144 361 575.765 361 570.36Z",
  fill: "url(#paint41_linear_9916_21076)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M330 81.7512C330 72.8349 336.275 65.6115 344.021 65.6115C351.767 65.6115 358.043 72.8349 358.043 81.7512C358.043 90.6675 351.767 97.8908 344.021 97.8908C336.275 97.8908 330 90.6675 330 81.7512Z",
  fill: "url(#paint42_linear_9916_21076)"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_9916_21076)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M289 429.596C289 431.322 288.669 432.992 288.062 434.57H234.59C234.553 434.534 234.535 434.497 234.498 434.46C234.498 434.497 234.479 434.534 234.461 434.57C234.461 434.57 233.026 434.57 230.433 434.607C203.963 434.754 56 435.58 56 434.277C56 419.226 67.5332 407.039 81.752 407.039C85.0813 407.039 88.2635 407.7 91.1698 408.911C93.8738 406.598 97.3319 405.24 101.066 405.24C106.474 405.24 111.275 408.103 114.144 412.49C114.181 412.417 114.218 412.325 114.255 412.251C117.014 406.396 122.385 401.459 129.338 398.229C134.911 395.623 141.478 394.117 148.541 394.117C150.583 394.117 152.588 394.246 154.538 394.485C162.024 379.911 176.648 370 193.46 370C214.963 370 232.916 386.225 236.907 407.736C239.317 406.158 242.168 405.24 245.222 405.24C251.347 405.24 256.663 408.893 259.293 414.27C261.942 413.316 264.867 412.784 267.957 412.784C276.271 412.784 283.445 416.638 286.866 422.218C288.227 424.439 289 426.953 289 429.596Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d_9916_21076)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M302.988 297.337C303.014 301.992 300.451 306.07 296.643 308.252L230.205 308.612C228.842 306.793 228.015 304.539 228 302.104C227.966 295.957 232.991 290.96 239.198 290.926C241.466 290.914 243.577 291.571 245.354 292.7C246.761 288.274 250.942 285.049 255.893 285.022C255.843 275.673 263.479 268.05 272.945 268C282.413 267.948 290.134 275.49 290.185 284.836C297.206 284.798 302.947 290.384 302.985 297.337H302.988Z",
  fill: "white"
})));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_9916_21076",
  x: 42,
  y: 356,
  width: 261,
  height: 93,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 7
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.808415 0 0 0 0 0.94851 0 0 0 0 1 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_9916_21076"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_9916_21076",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d_9916_21076",
  x: 214,
  y: 254,
  width: 102.988,
  height: 68.6121,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 7
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.808415 0 0 0 0 0.94851 0 0 0 0 1 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_9916_21076"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_9916_21076",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_9916_21076",
  x1: 19.5,
  y1: 12.0863,
  x2: 578.276,
  y2: 572.283,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CCDAFE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A1B6F9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_9916_21076",
  x1: 33.4844,
  y1: -0.999687,
  x2: 33.4844,
  y2: 559.307,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4FAF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.492971,
  stopColor: "#AFE3D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F4FAF8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_9916_21076",
  x1: 104,
  y1: -0.999687,
  x2: 104,
  y2: 559.307,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4FAF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.492971,
  stopColor: "#AFE3D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F4FAF8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_9916_21076",
  x1: 174.516,
  y1: -0.999687,
  x2: 174.516,
  y2: 559.307,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4FAF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.492971,
  stopColor: "#AFE3D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F4FAF8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_9916_21076",
  x1: 245.039,
  y1: -0.999687,
  x2: 245.039,
  y2: 559.307,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4FAF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.492971,
  stopColor: "#AFE3D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F4FAF8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_9916_21076",
  x1: 315.555,
  y1: -0.999687,
  x2: 315.555,
  y2: 559.307,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4FAF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.492971,
  stopColor: "#AFE3D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F4FAF8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_9916_21076",
  x1: 386.07,
  y1: -0.999687,
  x2: 386.07,
  y2: 559.307,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4FAF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.492971,
  stopColor: "#AFE3D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F4FAF8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_9916_21076",
  x1: 456.586,
  y1: -0.999687,
  x2: 456.586,
  y2: 559.307,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4FAF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.492971,
  stopColor: "#AFE3D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F4FAF8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear_9916_21076",
  x1: -87,
  y1: 383.137,
  x2: 671.048,
  y2: 383.137,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4FAF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.492971,
  stopColor: "#AFE3D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F4FAF8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear_9916_21076",
  x1: -87,
  y1: 319.031,
  x2: 671.048,
  y2: 319.031,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4FAF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.492971,
  stopColor: "#AFE3D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F4FAF8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear_9916_21076",
  x1: -87,
  y1: 254.925,
  x2: 671.048,
  y2: 254.925,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4FAF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.492971,
  stopColor: "#AFE3D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F4FAF8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear_9916_21076",
  x1: -87,
  y1: 190.819,
  x2: 671.048,
  y2: 190.819,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4FAF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.492971,
  stopColor: "#AFE3D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F4FAF8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint12_linear_9916_21076",
  x1: -87,
  y1: 126.712,
  x2: 671.048,
  y2: 126.712,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4FAF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.492971,
  stopColor: "#AFE3D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F4FAF8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint13_linear_9916_21076",
  x1: -87,
  y1: 62.6063,
  x2: 671.048,
  y2: 62.6062,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4FAF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.492971,
  stopColor: "#AFE3D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F4FAF8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint14_linear_9916_21076",
  x1: 465.059,
  y1: 303.88,
  x2: 444.545,
  y2: 303.88,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A8D5FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A8D5FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint15_linear_9916_21076",
  x1: 213.76,
  y1: 446.48,
  x2: 132.987,
  y2: 446.48,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A8D5FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A8D5FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint16_linear_9916_21076",
  x1: 411.263,
  y1: 659.237,
  x2: 500.531,
  y2: 614.149,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EAF8FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EAF8FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint17_linear_9916_21076",
  x1: 458,
  y1: 665.422,
  x2: -62.5,
  y2: 515.355,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#84D9F6",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.248671,
  stopColor: "#84D9F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E8EEFD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint18_linear_9916_21076",
  x1: 409.874,
  y1: 234.327,
  x2: 409.874,
  y2: 304.825,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AAE3F1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A8D5FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint19_radial_9916_21076",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(410.012 234.012) rotate(180) scale(14.1294)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CB73F8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.375,
  stopColor: "#EED0FD",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint20_linear_9916_21076",
  x1: 54,
  y1: 468.5,
  x2: 27,
  y2: 468.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BCE0FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E4F2FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint21_linear_9916_21076",
  x1: 82,
  y1: 292,
  x2: 309.5,
  y2: 134,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AF42E7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CB73F8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint22_linear_9916_21076",
  x1: 83.2028,
  y1: 315.67,
  x2: 304.053,
  y2: 156.541,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AF42E7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CB73F8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint23_linear_9916_21076",
  x1: 83.2028,
  y1: 343.227,
  x2: 297.612,
  y2: 182.093,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AF42E7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CB73F8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint24_linear_9916_21076",
  x1: 275.5,
  y1: 173.5,
  x2: 113,
  y2: 418.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8099F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5D70CC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint25_linear_9916_21076",
  x1: 197.905,
  y1: 142.49,
  x2: 197.905,
  y2: 228.43,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9FB4F9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5D70CC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint26_linear_9916_21076",
  x1: 197.905,
  y1: 108.33,
  x2: 197.905,
  y2: 196.06,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9FB4F9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5D70CC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint27_linear_9916_21076",
  x1: 197.475,
  y1: 73,
  x2: 197.475,
  y2: 167.55,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9FB4F9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5D70CC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint28_linear_9916_21076",
  x1: 186.501,
  y1: 326.5,
  x2: 282.35,
  y2: 358.13,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4053B0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5D70CC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint29_linear_9916_21076",
  x1: 433.192,
  y1: 262.192,
  x2: 433.192,
  y2: 347.536,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AAE3F1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A8D5FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint30_radial_9916_21076",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(433.242 262.242) rotate(180) scale(28.7693)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CB73F8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.375,
  stopColor: "#EED0FD",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint31_linear_9916_21076",
  x1: 306.792,
  y1: 340,
  x2: 306.792,
  y2: 488.237,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CDDBFE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B0E7FA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint32_linear_9916_21076",
  x1: 303.52,
  y1: 378.484,
  x2: 303.52,
  y2: 620.067,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5D70CC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A8D5FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint33_linear_9916_21076",
  x1: 229.561,
  y1: 340,
  x2: 229.561,
  y2: 515.077,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5D70CC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A8D5FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint34_linear_9916_21076",
  x1: 443.925,
  y1: 596.522,
  x2: -15.9971,
  y2: 596.522,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "#EAF8FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A8D5FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint35_linear_9916_21076",
  x1: 391.848,
  y1: 561.571,
  x2: 36.2534,
  y2: 561.571,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "#EAF8FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A8D5FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint36_linear_9916_21076",
  x1: 361.999,
  y1: 540.538,
  x2: 69.2727,
  y2: 540.538,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "#EAF8FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A8D5FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint37_linear_9916_21076",
  x1: 326.792,
  y1: 515.303,
  x2: 105.035,
  y2: 515.303,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "#EAF8FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A8D5FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint38_linear_9916_21076",
  x1: 313.78,
  y1: 505.54,
  x2: 116.08,
  y2: 505.54,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "#EAF8FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A8D5FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint39_linear_9916_21076",
  x1: 339.195,
  y1: 525.371,
  x2: 89.5037,
  y2: 525.371,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "#EAF8FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A8D5FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint40_linear_9916_21076",
  x1: 366.266,
  y1: 320.8,
  x2: 388.43,
  y2: 309.605,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EAF8FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EAF8FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint41_linear_9916_21076",
  x1: 358.763,
  y1: 580.144,
  x2: 379.271,
  y2: 569.786,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EAF8FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EAF8FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint42_linear_9916_21076",
  x1: 328.35,
  y1: 105.011,
  x2: 360.345,
  y2: 73.897,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EAF8FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EAF8FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_9916_21076"
}, /*#__PURE__*/React.createElement("rect", {
  width: 471,
  height: 640,
  fill: "white"
})));

function SvgOrganisation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 471,
    height: 640,
    viewBox: "0 0 471 640",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganisation);
export default __webpack_public_path__ + "static/media/Organisation.ef4e6fd3d74d2e2dacb3488ce6200810.svg";
export { ForwardRef as ReactComponent };